<div class="main-form">
  <div class="sign-up">
    <h1 *ngIf="!isHideTitle">Sign up to get started</h1>
    <h2 translate>
      lbl_already_acc
      <a (click)="goToSignIn()" class="sign-up-link" translate>
        label_sign_in
      </a>
    </h2>
    <form [formGroup]="signUpForm">
      <div class="double-form-row">
        <div class="form-row-input">
          <span>
            <label for="firstName">{{ 'label_first_name' | translate }}*</label>
            <input
              id="firstName"
              placeholder="{{ 'label_first_name' | translate }}"
              appNoLeadingSpace
              autocomplete="given-name"
              class="bordered-input"
              formControlName="firstName"
              maxlength="30"
              pInputText
              size="30"
              type="text"
            />
          </span>
          <div
            *ngIf="signUpForm.controls?.firstName.dirty && signUpForm.controls?.firstName.errors?.required"
            class="error-sign"
            translate
          >
            err_required_firstname
          </div>
          <div
            *ngIf="signUpForm.controls.firstName.dirty && signUpForm.controls.firstName.errors?.pattern"
            class="error-sign"
            translate
          >
            err_invalid_firstname
          </div>
        </div>
        <div class="form-row-input">
          <span>
            <label for="lastName">{{ 'label_last_name' | translate }}*</label>
            <input
              id="lastName"
              placeholder="{{ 'label_last_name' | translate }}"
              appNoLeadingSpace
              autocomplete="family-name"
              class="bordered-input"
              formControlName="lastName"
              maxlength="30"
              pInputText
              size="30"
              type="text"
            />
          </span>
          <div
            *ngIf="signUpForm.controls.lastName.dirty && signUpForm.controls.lastName.errors?.required"
            class="error-sign"
            translate
          >
            err_required_lastname
          </div>
          <div
            *ngIf="signUpForm.controls.lastName.dirty && signUpForm.controls.lastName.errors?.pattern"
            class="error-sign"
            translate
          >
            err_invalid_lastName
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-row-input">
          <span>
            <label for="emailId">
              {{ 'label_email_address' | translate }}*
            </label>
            <input
              id="emailId"
              [attr.disabled]="
                isVerifiedEmail || isVerifiedPhone ? true : undefined
              "
              appNoLeadingSpace
              autocomplete="email"
              class="bordered-input"
              placeholder="{{ 'label_email_address' | translate }}"
              formControlName="emailId"
              maxlength="100"
              pInputText
              size="30"
              type="email"
            />
          </span>
          <div
            *ngIf="signUpForm.controls.emailId.dirty && signUpForm.controls.emailId.errors?.required"
            class="error-sign"
            translate
          >
            err_required_emailId
          </div>
          <div
            *ngIf="signUpForm.controls.emailId.dirty && signUpForm?.controls?.emailId.errors?.pattern"
            class="error-sign"
            translate
          >
            err_invalid_emailId
          </div>
          <div
            *ngIf="signUpForm?.controls?.emailId.errors?.notUnique"
            class="error-sign"
            translate
          >
            This email is already registered.
          </div>
        </div>
      </div>
      <div class="double-form-row">
        <div class="form-row-input">
          <span>
            <app-country-input
              label="{{ 'label_mobile_number' | translate }}*"
              placeholder="{{ 'label_mobile_number' | translate }}"
              [disabled]="isVerifiedPhone || isVerifiedEmail"
              [isNewControlResponse]="true"
              formControlName="phone"
              [containerStyleClass]="'bordered-container-gray'"
              [inputStyleClass]="'borderless'"
              [flagDropdownStyle]="'borderless'"
              [floatLabel]="false"
            >
            </app-country-input>
          </span>
          <div
            *ngIf="
              signUpForm.controls.phone.dirty && signUpForm.controls.phone.errors?.required
            "
            class="error-sign"
            translate
          >
            err_required_contact
          </div>
          <div
            *ngIf="
              signUpForm.controls.phone.dirty && signUpForm.controls.phone.errors?.pattern
            "
            class="error-sign"
            translate
          >
            err_required_contact
          </div>
          <div
            *ngIf="signUpForm.controls.phone.errors?.notUnique"
            class="error-sign"
            translate
          >
            This number is already registered.
          </div>
        </div>
        <div class="form-row-input">
          <span>
            <label for="zipCode" translate>label_zip_code</label>
            <input
              id="zipCode"
              (keydown)="onPaste($event, 'zipCode')"
              (keyup)="toUppercase('zipCode')"
              appNoLeadingSpace
              autocomplete="postal-code"
              placeholder="{{ 'label_zip_code' | translate }}"
              class="bordered-input"
              formControlName="zipCode"
              maxlength="7"
              pInputText
              size="30"
              type="text"
            />
          </span>
          <div
            *ngIf="signUpForm.controls.zipCode.dirty && signUpForm.controls.zipCode.errors?.required"
            class="error-sign"
            translate
          >
            err_required_zip
          </div>
          <div
            *ngIf="signUpForm.controls.zipCode.dirty && signUpForm.controls.zipCode.errors?.pattern"
            class="error-sign"
            translate
          >
            err_invalid_zip_code
          </div>
        </div>
      </div>
      <div class="double-form-row">
        <div class="form-row-input align-content-start">
          <span class="relative">
            <label for="password"> {{ 'label_create_password' | translate }}* </label>
            <input
              id="password"
              #passwordInput
              (blur)="showPasswordRequirements = false"
              (focus)="showPasswordRequirements = true"
              [feedback]="false"
              appNoLeadingSpace
              class="bordered-input"
              placeholder="{{ 'placeholder_create_password' | translate }}"
              formControlName="password"
              minlength="3"
              pPassword
              size="30"
              type="password"
            />
            <div
              (click)="togglePassword()"
              *ngIf="isPasswordVisible('password')"
              class="sprite eye"
            ></div>
            <div
              (click)="togglePassword()"
              *ngIf="!isPasswordVisible('password')"
              class="sprite close-eye"
            ></div>
          </span>
          <div *ngIf="showPasswordRequirements" class="password-validator">
            <label
              [ngClass]="
                signUpForm.controls['password'].hasError('required') ||
                signUpForm.controls['password'].hasError('minlength')
                  ? 'text-danger'
                  : 'text-success'
              "
            >
              <i
                [ngClass]="{
                  'pi-times-circle':
                    signUpForm.controls['password'].hasError('required') ||
                    signUpForm.controls['password'].hasError('minlength'),
                  'pi-check-circle': !(
                    signUpForm.controls['password'].hasError('required') ||
                    signUpForm.controls['password'].hasError('minlength')
                  )
                }"
                class="pi"
              >
              </i>
              8 characters
            </label>
            <label
              [ngClass]="
                signUpForm.controls['password'].hasError('required') ||
                signUpForm.controls['password'].hasError('hasNumber')
                  ? 'text-danger'
                  : 'text-success'
              "
            >
              <i
                [ngClass]="{
                  'pi-times-circle':
                    signUpForm.controls['password'].hasError('required') ||
                    signUpForm.controls['password'].hasError('hasNumber'),
                  'pi-check-circle': !(
                    signUpForm.controls['password'].hasError('required') ||
                    signUpForm.controls['password'].hasError('hasNumber')
                  )
                }"
                class="pi"
              ></i>
              1 number
            </label>
            <label
              [ngClass]="
                signUpForm.controls['password'].hasError('required') ||
                signUpForm.controls['password'].hasError('hasCapitalCase')
                  ? 'text-danger'
                  : 'text-success'
              "
            >
              <i
                [ngClass]="{
                  'pi-times-circle':
                    signUpForm.controls['password'].hasError('required') ||
                    signUpForm.controls['password'].hasError('hasCapitalCase'),
                  'pi-check-circle': !(
                    signUpForm.controls['password'].hasError('required') ||
                    signUpForm.controls['password'].hasError('hasCapitalCase')
                  )
                }"
                class="pi"
              ></i>
              1 uppercase letter
            </label>
            <label
              [ngClass]="
                signUpForm.controls['password'].hasError('required') ||
                signUpForm.controls['password'].hasError('hasSmallCase')
                  ? 'text-danger'
                  : 'text-success'
              "
            >
              <i
                [ngClass]="{
                  'pi-times-circle':
                    signUpForm.controls['password'].hasError('required') ||
                    signUpForm.controls['password'].hasError('hasSmallCase'),
                  'pi-check-circle': !(
                    signUpForm.controls['password'].hasError('required') ||
                    signUpForm.controls['password'].hasError('hasSmallCase')
                  )
                }"
                class="pi"
              ></i>
              1 lowercase letter
            </label>
          </div>
        </div>
        <div class="form-row-input align-content-start">
          <span class="relative">
            <label for="repassword">
              {{ 'label_confirm_password' | translate }}*
            </label>
            <input
              id="repassword"
              #repasswordInput
              (keypress)="signUpForm.get('repassword').markAsTouched()"
              appNoLeadingSpace
              class="bordered-input"
              placeholder="{{ 'label_confirm_password' | translate }}"
              formControlName="repassword"
              minlength="3"
              pInputText
              size="30"
              type="password"
            />
            <div
              (click)="toggleRepassword()"
              *ngIf="isPasswordVisible('repassword')"
              class="sprite eye"
            ></div>
            <div
              (click)="toggleRepassword()"
              *ngIf="!isPasswordVisible('repassword')"
              class="sprite close-eye"
            ></div>
          </span>
          <div
            *ngIf="signUpForm.controls.repassword.dirty && signUpForm.controls.repassword.errors?.notEqual"
            class="error-sign"
            translate
          >
            err_confirm_password_not_match
          </div>
          <div
            *ngIf="
              submitted &&
              signUpForm.controls.repassword.errors?.pattern &&
              (signUpForm.controls.repassword.dirty ||
                signUpForm.controls.repassword.touched)
            "
            class="error-sign"
            translate
          >
            err_invalid_password_length
          </div>
        </div>
      </div>
      <div *ngIf="errorMessage" class="form-row">
        <div class="error-sign">
          {{ errorMessage }}
        </div>
      </div>
      <p class="description-text">
        By signing up, you are confirming that you accept Pitch59’s
        <a href="{{ baseUrl + '/terms-and-conditions' }}">Terms of Service</a>
        and
        <a href="{{ baseUrl + '/privacy-policy' }}">Privacy Policy</a>.
      </p>
      <div class="form-row" *ngIf="!isHideMainButton">
        <button
          (click)="sendOtp($event, { type: 'email' })"
          [disabled]="!signUpForm.valid"
          [ngClass]="{ disabled: !signUpForm.valid }"
          class="button-simple sm-35 primary-btn"
          style="height: 44px; width: 100%; padding: 11px 0"
          translate
        >
          Sign up
        </button>
      </div>
      <div class="divider-or" *ngIf="!isHideMainButton">
        <span translate>label_or</span>
      </div>
      <button
        *ngIf="!isHideMainButton"
        type="button"
        class="google-sign-btn"
        (click)="signUpWithGoogle()"
      >
        <svg class="google-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        <span translate>label_sign_up_with_google</span>
      </button>
      <button
        *ngIf="!isHideMainButton"
        type="button"
        class="apple-sign-btn"
        (click)="signUpWithApple()"
      >
        <svg class="apple-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M16.365 12.822c-.017-1.863 1.522-2.758 1.591-2.8-.868-1.267-2.219-1.441-2.696-1.461-1.148-.116-2.241.676-2.825.676-.586 0-1.494-.659-2.456-.641-1.264.019-2.43.735-3.082 1.872-1.316 2.279-.334 5.65.945 7.499.626.904 1.372 1.919 2.351 1.882.943-.038 1.298-.61 2.439-.61 1.14 0 1.459.61 2.458.591.998-.018 1.629-.904 2.249-1.81.72-1.052 1.016-2.07 1.034-2.123-.022-.01-1.979-.76-2.008-3.085zm-1.448-5.644c.519-.63.869-1.507.773-2.378-.747.03-1.652.498-2.188 1.127-.481.558-.903 1.45-.789 2.302.833.065 1.685-.423 2.204-1.051z"/>
        </svg>
        <span translate>label_sign_up_with_apple</span>
      </button>
    </form>
  </div>
  <p class="footer-info" *ngIf="!isHideHelpCenter">
    For information on how to sign up check out our <a
    href="https://help.pitch59.com/knowledge"
  >Help Center article</a
    >
  </p>
</div>
<p-toast [style]="{ marginTop: '70px' }" key="support">
  <ng-template pTemplate>
    <span
    >If you are still having problems, please call Pitch59 Customer
      Support:</span
    ><br />
    <a
      href="tel:+18324124070"
      style="color: white; margin-top: 5px; text-decoration: none"
    >(832) 412-4070</a
    >
  </ng-template>
</p-toast>

<p-dialog
  (visibleChange)="visibleChange($event)"
  [visible]="otpModalSig()"
  [blockScroll]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  [style]="{ minWidth: '300px', maxWidth: '400px', width: '100%' }"
  appendTo="body"
  styleClass="dialog otp-dialog"
>
  <div *ngIf="otpModal">
    <div class="pr-3 pl-3 header-block text-center mb-20">
      <h2 class="title">Verify your account</h2>
      <span class="sub-title">Your code has been emailed to:</span>
      <br />
      <span class="word-break email">
        {{
          otpRequestModel.type === 'phone'
            ? signUpForm.value.contactNumber
            : signUpForm.value.emailId
        }}
      </span>
    </div>

    <div class="main-content text-center mb-30">
      <h1 class="main-title">Enter Code</h1>
      <div class="input-wrap margin-centered">
        <app-verify-form
          (otpCode)="verifyOtp($event)"
          (resentOtp)="sendOtp($event, { type: 'email' })"
          [errorMessage]="otpCodeErrorMessage"
          [messageResource]="defaultResourceType"
        ></app-verify-form>
      </div>
    </div>
  </div>
</p-dialog>
